import { useMemo } from 'react'
import type { ColumnDef } from '@tanstack/react-table'
import { Table } from '../../../../shared/components'
import { createOrderColumns } from '../../utils/columns'
import type { Order } from '../../types/orders.types'

interface OrdersTableProps {
  isLoading: boolean
  data: Order[]
  onViewDetails: (order: Order) => void
  merchantMap?: Map<string, string>
}

export function OrdersTable({ isLoading, data, onViewDetails, merchantMap }: OrdersTableProps) {
  const columns = useMemo(() => createOrderColumns(onViewDetails, merchantMap), [onViewDetails, merchantMap])
  console.log('OrdersTable rendered with data:', data)

  return <Table data={data} columns={columns as ColumnDef<Order>[]} isLoading={isLoading} />
}